<template>
  <div class="n-conversation">
    <n-conversation-thread
      :messages="messages"
      :outboundMessageColour="outboundMessageColour"
      :displayAvatar="displayAvatar"
      :enableAvatarTooltip="enableAvatarTooltip"
      :readonlyApps="readonlyApps"
      @sendQuickReply="(quickReply: string) => emit('sendQuickReply', quickReply)"
    ></n-conversation-thread>
    <n-message-composer
      :accentColour="outboundMessageColour"
      @messageSend="(messageText: string) => emit('messageSend', messageText)"
      @conversationRead="emit('conversationRead')"
      @typingStart="emit('typingStart')"
      @typingStop="emit('typingStop')"
    ></n-message-composer>
  </div>
</template>

<script lang="ts" setup>
import NConversationThread from './conversation-thread.vue';
import NMessageComposer from './message-composer.vue';
import { Message } from './message';
import { PropType } from 'vue';

defineOptions({
  name: 'n-conversation',
});

const emit = defineEmits<{
  (e: 'messageSend', messageText: string): void;
  (e: 'sendQuickReply', quickReply: string): void;
  (e: 'conversationRead'): void;
  (e: 'typingStart'): void;
  (e: 'typingStop'): void;
}>();

defineProps({
  messages: {
    type: Array as PropType<Message[]>,
    required: true,
  },
  outboundMessageColour: {
    type: String,
    default: '#062b80',
  },
  displayAvatar: {
    type: Boolean,
    default: false,
  },
  enableAvatarTooltip: {
    type: Boolean,
    default: false,
  },
  readonlyApps: {
    type: Boolean,
    default: true,
  },
});
</script>
